import React from 'react';
import RatesEditor from './RatesEditor';

// Client charge rates. These price shifts for the margin and profit reports only; invoices are
// priced from Price Books, which the page says up front.
const CONFIG = {
  noun: 'client',
  endpoint: '/financials/client-rates',
  idField: 'client_id',
  nameField: 'client_name',
  peopleUrl: '/clients?limit=500',
  peopleKey: 'clients',
  personLabel: 'Client',
  defaultLabel: 'Default (all clients)',
  allLabel: 'All clients',
  empty: { client_id: '', shift_type: '', standard_rate: '', saturday_rate: '', sunday_rate: '', public_holiday_rate: '', pay_type: 'hourly', valid_from: '', valid_to: '' },
  intro: 'Charge rates used for margin and profit reports. Invoices are priced from Price Books, so changing a rate here does not change an invoice.',
  link: { to: '/settings/prices', label: 'Open price books' },
  emptyHint: 'Add a rate, or sync them from the price book assigned to each client.',
  drawerHint: 'Used for margin and profit reports only.',
  sync: {
    url: '/financials/sync-client-rates',
    label: 'Sync from price books',
    title: 'Sync client rates from price books?',
    confirm: "This creates or updates each client's rates from their assigned price book. Rates you have entered by hand for the same client and shift type are overwritten.",
    processedKey: 'clients_processed',
  },
};

export default function ClientRates() {
  return <RatesEditor cfg={CONFIG} />;
}
